// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"YW-z","sponsoredTooltipWrapper":"ZW-z","sponsoredTooltip":"_W-z","newCard":"aX-z"};